import * as React from 'react';
import { I18n } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import ResourceSelector from '../../ResourceSelector';
import Popup from '../../Popup';
import {
	createProposalFromDesktopFile,
	createProposalFromDriveItem,
	hideProposalCreator,
	removeFromCreationProgress,
} from '../../../containers/ProposalCreator/actions';
import { ProposalCreationStatus } from '../../../containers/ProposalCreator/reducer';
import { FileError } from '../../../containers/ImportManager/actions';
import { PopupBodyWrapper } from '../styles';
import DriveItemUtils from '../../../utils/driveItem';

interface FromFileProps {
	isDisplayed: boolean;
	isImportingFile: boolean;
	importingStatus: ProposalCreationStatus;
	importingPercentage: number;
	importingError: FileError | null;
	dispatch: Dispatch<StoreState>;
}

const id = 'create-proposal';
const desktopFileExtensions = ['.pdf', '.epub', '.ppt', '.pptx', '.doc', '.docx', '.otp', '.odt', '.png', '.jpg', '.jpeg'];

const FromFile = ({
	isDisplayed,
	isImportingFile,
	importingStatus,
	importingPercentage,
	importingError,
	dispatch,
}: FromFileProps) => {
	const getLabel = () => (
		importingStatus
			? `messages.${importingStatus.toLowerCase()}`
			: 'messages.create_proposal'
	);

	const handleCancelClick = () => {
		dispatch(hideProposalCreator());
	};

	return (
		<Popup
			isDisplayed={isDisplayed}
			label={I18n.t(getLabel())}
			onCancel={handleCancelClick}
		>
			<PopupBodyWrapper>
				<ResourceSelector
					id={id}
					fileExtensions={desktopFileExtensions}
					isFileExtensionsDisplayed={false}
					isValidResourceFromApp={DriveItemUtils.isValidResourceForProposal}
					isImportingFile={isImportingFile}
					importingPercentage={importingPercentage}
					importingError={importingError}
					isProcessingVideo={false}
					onSelect={resource => dispatch(createProposalFromDriveItem(resource, id))}
					customImportHandler={(file, isCorrectFileType) => dispatch(createProposalFromDesktopFile(file as File, isCorrectFileType, id))}
					onFileImportCancel={() => dispatch(removeFromCreationProgress())}
					dispatch={dispatch}
				/>
			</PopupBodyWrapper>
		</Popup>
	);
};

export default FromFile;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalCreator/FromFile/index.tsx